(function() {

    angular
        .module('app')
        .directive('slider', slider);
    	slider.$inject = ["$location"];

        	function slider($location) {
			    return {
			        restrict: 'E',
		            templateUrl: 'static/app/views/directive/slider.html',
			        link: function ( scope, elem, attrs ) {

			        	
			        }
			    };
			}


})();
